import { render } from "./TemplateCitas.vue?vue&type=template&id=6cf2fe82"
import script from "./TemplateCitas.vue?vue&type=script&lang=js"
export * from "./TemplateCitas.vue?vue&type=script&lang=js"

import "./TemplateCitas.vue?vue&type=style&index=0&id=6cf2fe82&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__